export default __webpack_public_path__ + "static/media/Serata finale.aa89ee3e.jpg";